import { CoMailOpen } from "@onemind-services-llc/react-icons-ng/co";
import { FaLocationArrow, FaPhoneAlt } from "@onemind-services-llc/react-icons-ng/fa";
import { MdOutlineSupport } from "@onemind-services-llc/react-icons-ng/md";
import { IAAS_ROUTES, MAIN_ROUTES, NETWORK_SERVICES_ROUTES } from "@/constants/routes";

export const FOOTER_CONSTANTS = {
  BRAND_TEXT:
    "“Our Expertise, Your Success is our Mission Statement. We are Customer Experts.”",
  CONTACT_INFO: "CONTACT INFO",
  DONT_MISS_UPDATES: "Don't miss our future updates. Get subscribed today !",
  IAAS_SERVICE: "IAAS",
  GENERAL_POLICIES: " GENERAL POLICIES",
  DEDICATED_SERVERS_POLICY: "DEDICATED SERVERS POLICIES",
  CLOUD_SERVERS_POLICY: "CLOUD SERVERS POLICIES",
  COLOCATION_POLICY: "COLOCATION POLICIES",
  RIGHTS: `© 2021 - ${new Date().getFullYear()} | All rights reserved by OneMind Cloud Services Pvt. Ltd.`,
  SUPPORT: "SUPPORT",
  SERVICES: "SERVICE",
  SUBSCRIBE: "Subscribe For Newsletter",
};

export const CONTACT_INFO_LIST = [
  {
    icon: CoMailOpen,
    label: "sales@onemindservices.in",
    path: "mailto:sales@onemindservices.in",
  },
  {
    icon: MdOutlineSupport,
    label: "support@onemindservices.in",
    path: "mailto:support@onemindservices.in",
  },

  { icon: FaPhoneAlt, label: "+91 92173 62021", path: "tel:+919217362021" },
  {
    icon: FaLocationArrow,
    label:
      "8th Floor ,Magnum Towers-1, Sector 58, Golf Course Extension Road, Gurgaon, Haryana 122011",
    path: "https://maps.google.com?q=Magnum Towers, Sector 58, Golf Course Extension Road, Gurgaon, Haryana 122011",
    ext_link: true,
  },
];

export const SERVICE_OPTIONS = [
  { name: "Cloud Services", path: `${MAIN_ROUTES.CLOUD_SERVICES}` },
  { name: "Network Services", path: `${MAIN_ROUTES.NETWORK_SERVICES}` },
  { name: "Application Services", path: `${MAIN_ROUTES.APPLICATION_SERVICES}` },
  {
    name: "VMware Migration",
    path: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.VMWARE_MIGRATION}`,
  },
  {
    name: "Migrate To Zadara",
    path: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.MIGRATE_TO_ZADARA}`,
  },
];

export const IAAS_SERVICES = [
  { name: "Bare-Metal Server", path: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.BAREMETAL}` },
  {
    name: "Dedicated Servers",
    path: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.DEDICATED_SERVER}`,
  },
  { name: "GPU Hosting", path: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.GPU_HOSTING}` },
  {
    name: "Virtual Desktop Infrastructure (VDI) ",
    path: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.VDI}`,
  },
  {
    name: "Block Storage | S3 Storage ",
    path: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.BLOCK_AND_S3_STORAGE}`,
  },
  {
    name: "Disaster Recovery ",
    path: `${MAIN_ROUTES.IAAS}${IAAS_ROUTES.DISASTER_RECOVERY}`,
  },
];

export const SUPPORT_OPTIONS = [
  { name: "Home", path: "/" },
  { name: "About us", path: MAIN_ROUTES.ABOUT_US },
  { name: "Contact us", path: MAIN_ROUTES.BOOK_A_CONSULTATION },
  { name: "Data Centers", path: MAIN_ROUTES.DATA_CENTER },
];

export const GENERAL_POLICIES_OPTION = [
  { name: "Accepted Use Policy ", path: MAIN_ROUTES.ACCEPTED_USE_POLICY },
  { name: "Code Of Conduct", path: MAIN_ROUTES.CODE_OF_CONDUCT },
  { name: "Digital Millenium Coypyright Act", path: MAIN_ROUTES.DMCA },
  { name: "Bandwidth and Backup Overages", path: MAIN_ROUTES.BANDWIDTH_BACKUP_OVERAGES },
  {
    name: "OneMind Services: Industry-Leading Service Level Guarantee",
    path: MAIN_ROUTES.SERVICE_GUARANTEE,
  },
];

export const DEDICATED_SERVERS_POLICY = [
  {
    name: "OneMind's Hosting Master Services Agreement",
    path: MAIN_ROUTES.HOSTING_SERVICES_AGREEMENT,
  },
  {
    name: "OneMind's Dedicated Server Service Level Guarantee",
    path: MAIN_ROUTES.DEDICATED_SERVICE_LEVEL_GUARANTEE,
  },
];

export const CLOUD_SERVERS_POLICY = [
  {
    name: "OneMind Cloud Service Level Agreement (SLA)",
    path: MAIN_ROUTES.CLOUD_SERVICE_LEVEL_AGREEMENT,
  },
  {
    name: "OneMind Cloud Terms of Service",
    path: MAIN_ROUTES.CLOUD_TERMS_OF_SERVICE,
  },
];

export const COLOCATION_POLICY = [
  {
    name: "OneMind Services Hosting Master Services Agreement",
    path: MAIN_ROUTES.HOSTING_COLOCATIONS_ERVICES_AGREEMENT,
  },
  {
    name: "OneMind Services Colocation Policies and Regulations",
    path: MAIN_ROUTES.COLOCATION_POLICIES_AND_REGULATIONS,
  },
];
